module.exports = __webpack_public_path__ + "img/zlpg.af765c3.png";